const templateContent = {
    german: {
        homepage: "Startseite",
        schedule: "Programm",
        projects: "Projekte",
        digital: "Digitales",
        about: "Über",
        cooperations: "Partner:innen",
        blog: "Blog",
        tickets: "Tickets",
        accessibility: "Barrierefreiheit",
        help: "Hilfe und Awareness",
        team: "Team und Kontakt",
        legalNotice: "Impressum",
        newsLetter: "nOus-Letter",
        sponsor: "Website gefördert durch",
        buttonGerman: "zu deutscher Sprache wechseln",
        buttonEnglish: "zu englischer Sprache wechseln",
        buttonChangeFontsize: "Schriftgröße ändern",
        buttonChangeContrast: "Kontrast ändern",
        share: "teilen",
        logoFemphils: "Kooperationsseite femphils*",
        logoLadiez: "Kooperationsseite Ladiez e.V.",
        logoMousonturm: "Kooperationsseite Künstlerhaus Mousonturm",
        logoHafen2: "Kooperationsseite Hafen 2",
        logoFonds: "Startseite Fonds Soziokultur",
        logoHmwk: "Startseite Hessisches Ministerium für Wissenschaft und Kultur",
        logoGoetheUni: "Startseite Goethe Universität Frankfurt",
        logoTheater: "Startseite Hessische Theaterakademie",
        logoFrauenreferat: "Startseite Frauenreferat Frankfurt",
        logoStabstelle: "Startseite Stabstelle Inklusion Frankfurt",


    },
    english: {
        homepage: "Homepage",
        schedule: "Programme",
        projects: "Projects",
        digital: "Digital",
        about: "About",
        cooperations: "Partners",
        blog: "Blog",
        tickets: "Tickets",
        accessibility: "Accessibility",
        help: "Help and Awareness",
        team: "Team and Contact",
        legalNotice: "Legal Notice",
        newsLetter: "nOus-Letter",
        sponsor: "Website funded by",
        buttonGerman: "switch to german language",
        buttonEnglish: "switch to englisch language",
        buttonChangeFontsize: "change font size",
        buttonChangeContrast: "change contrast",
        share: "share",
        logoFemphils: "cooperation page femphils*",
        logoLadiez: "cooperation page Ladiez e.V.",
        logoMousonturm: "cooperation page Künstlerhaus Mousonturm",
        logoHafen2: "cooperation page Hafen 2",
        logoFonds: "home page Fonds Soziokultur",
        logoHmwk: "home page Hessisches Ministerium für Wissenschaft und Kultur",
        logoGoetheUni: "home page Goethe Universität Frankfurt",
        logoTheater: "home page Hessische Theaterakademie",
        logoFrauenreferat: "home page Frauenreferat Frankfurt",
        logoStabstelle: "home page Stabstelle Inklusion Frankfurt",

    },
    simpleGerman: {
        homepage: "Startseite",
        schedule: "Programm",
        projects: "Künstler*innen",
        digital: "Digitales",
        about: "Über",
        cooperations: "Kooperationen",
        blog: "Blog",
        tickets: "Tickets",
        accessibility: "Barrierefreiheit",
        help: "Hilfe/Code of Conduct",
        team: "Team und Kontakt",
        legalNotice: "Impressum",
        newsLetter: "nOus-Letter",
        sponsor: "Website gefördert durch"
    }
}

export {templateContent}